export enum CatalogItemTypeEnum {
  GAMES = 'games',
  CATEGORIES = 'categories',
  PROVIDERS = 'providers',
  SPORTS = 'sports',
  SPORTS_ITEM = 'sports-item',
  TEAMS = 'teams',
  TOURNAMENTS = 'tournaments',
  MARKET = 'markets',
}
